'use strict';

import settings from '../settings';
import { HttpContext } from '../utils/httpContext';

class EsemenyNaptarService {
  async GetCalendar(date) {
    let data = { date };
    const url = settings.baseUrl + 'Api/EsemenyNaptar/GetCalendar';
    const result = await HttpContext.post({ url, data });
    return result;
  }
}

let instance = new EsemenyNaptarService();
export { instance as esemenyNaptarService };
